// Modules
import React from 'react'
import PropTypes from 'prop-types'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Logo.scss'

// Component: Brand > Logo
function Logo ({ className, isCommonColor, isSmall, style }) {
	// Data
	// const { translate } = useLanguage('components.brand.logo')
	const color = isCommonColor ? 'var(--brand-common-color)' : 'var(--brand-adaptive-color)'

	// Render
	return (
		<svg
			data-brand="logo"
			viewBox={`0 0 ${isSmall ? 11 : 64} 15`}
			className={
				'aix-logo' +
				(className ? ` ${className}` : '')
			}
			style={style}>
			{isSmall
				? <polygon
					fill={color}
					points="2.2666666 -3.01980663e-14 5.2763333 5.643 7.6333833 2.5 10.1332833 2.5 6.3143333 7.591 10.2666666 15 8 15 4.9903333 9.357 2.6333833 12.5 0.1333833 12.5 3.9513333 7.41 0 -3.01980663e-14" />
				: <path
					fill={color}
					d="M30,2.5 C32.7614237,2.5 35,4.73857625 35,7.5 C35,10.2614237 32.7614237,12.5 30,12.5 C28.8743068,12.5 27.8354995,12.1279975 26.9998057,11.5002202 L27,15 L25,15 L25,2.5 L26.4644661,3.96446609 C27.3692881,3.05964406 28.6192881,2.5 30,2.5 Z M16.3833333,-5.68434189e-14 L19.393,5.643 L21.75005,2.5 L24.24995,2.5 L20.431,7.591 L24.3833333,15 L22.1166667,15 L19.107,9.357 L16.75005,12.5 L14.25005,12.5 L18.068,7.41 L14.1166667,-5.68434189e-14 L16.3833333,-5.68434189e-14 Z M59,2.5 C61.7614237,2.5 64,4.73857625 64,7.5 L64,12.5 L62,12.5 L62,7.5 C62,5.84314575 60.6568542,4.5 59,4.5 C57.3431458,4.5 56,5.84314575 56,7.5 L56,12.5 L54,12.5 L54,2.5 L55.4644661,3.96446609 C56.3692881,3.05964406 57.6192881,2.5 59,2.5 Z M52.5,2.5 L52.5,12.5 L50.5,12.5 L50.5,2.5 L52.5,2.5 Z M49,2.5 L49,12.5 L47.5355339,11.0355339 C46.6307119,11.9403559 45.3807119,12.5 44,12.5 C41.2385763,12.5 39,10.2614237 39,7.5 C39,4.73857625 41.2385763,2.5 44,2.5 C45.3812096,2.5 46.6316131,3.06004763 47.5365123,3.96544477 L49,2.5 Z M38,-5.15143483e-14 L38,12.5 L36,12.5 L36,-5.15143483e-14 L38,-5.15143483e-14 Z M13.5,2.5 L13.5,12.5 L11.5,12.5 L11.5,2.5 L13.5,2.5 Z M10,2.5 L10,12.5 L8.53553391,11.0355339 C7.63071187,11.9403559 6.38071187,12.5 5,12.5 C2.23857625,12.5 0,10.2614237 0,7.5 C0,4.73857625 2.23857625,2.5 5,2.5 C6.38120961,2.5 7.63161308,3.06004763 8.53651231,3.96544477 L10,2.5 Z M44,4.5 C42.3431458,4.5 41,5.84314575 41,7.5 C41,9.15685425 42.3431458,10.5 44,10.5 C45.6568542,10.5 47,9.15685425 47,7.5 C47,5.84314575 45.6568542,4.5 44,4.5 Z M30,4.5 C28.3431458,4.5 27,5.84314575 27,7.5 C27,9.15685425 28.3431458,10.5 30,10.5 C31.6568542,10.5 33,9.15685425 33,7.5 C33,5.84314575 31.6568542,4.5 30,4.5 Z M5,4.5 C3.34314575,4.5 2,5.84314575 2,7.5 C2,9.15685425 3.34314575,10.5 5,10.5 C6.65685425,10.5 8,9.15685425 8,7.5 C8,5.84314575 6.65685425,4.5 5,4.5 Z M52.5,-5.11812814e-14 L52.5,1.5 L50.5,1.5 L50.5,-5.11812814e-14 L52.5,-5.11812814e-14 Z M13.5,-5.11812814e-14 L13.5,1.5 L11.5,1.5 L11.5,-5.11812814e-14 L13.5,-5.11812814e-14 Z" />
			}
		</svg>
	)
}

// Properties
Logo.propTypes = {
	className: PropTypes.string,
	isCommonColor: PropTypes.bool,
	isSmall: PropTypes.bool,
	style: PropTypes.object
}
Logo.defaultProps = {
	isCommonColor: false,
	isSmall: false
}

// Export
export default Logo
